import { throttle } from 'lodash';

const inPageNav = document.querySelector('.block-inpage-menu');
const contentBlock = inPageNav.querySelector('.block-inpage-menu__content');
const activeClass = 'block-inpage-menu--active';

// Create the label element and append it to the top of block-inpage-menu__content
const labelBlock = document.createElement('div');
labelBlock.className = 'block-inpage-menu__label';
contentBlock.prepend(labelBlock); // Add it to the beginning of the content block

// Create the title element and append it to the labelBlock
const titleElement = document.createElement('span');
titleElement.className = 'block-inpage-menu__title';
labelBlock.append(titleElement);

const navLinks = inPageNav.querySelectorAll('.is-style-navigation-link a');

// Remove invalid links and their parent elements
navLinks.forEach((link) => {
	const sectionId = link.getAttribute('href')?.substring(1); // Get the ID without the #
	const section = document.getElementById(sectionId);

	if (!section) {
		// Remove the parent element (wp-block-button) if the ID doesn't exist
		const parentButton = link.closest('.wp-block-button');
		if (parentButton) {
			parentButton.remove();
		}
	}
});

// Re-fetch navLinks after invalid links are removed
const validNavLinks = inPageNav.querySelectorAll('.is-style-navigation-link a');

// Initialize the title element with the first valid nav link's text
if (validNavLinks.length > 0) {
	titleElement.textContent = validNavLinks[0].textContent;
}

// Function to update the active class based on the section in view
let lastActiveLink = null;

function updateActiveNav() {
	let currentActiveLink = null;

	validNavLinks.forEach((link) => {
		const sectionId = link.getAttribute('href').substring(1); // Get the ID without the #
		const section = document.getElementById(sectionId);

		if (section) {
			const sectionTop = section.getBoundingClientRect().top;
			const sectionBottom = section.getBoundingClientRect().bottom;

			if (
				sectionTop <= window.innerHeight / 2 &&
				sectionBottom >= window.innerHeight / 2
			) {
				currentActiveLink = link;
				link.parentElement.classList.add('block-inpage-menu__selected');
			} else {
				link.parentElement.classList.remove(
					'block-inpage-menu__selected'
				);
			}
		}
	});

	if (currentActiveLink) {
		// Update the title element with the current active link text
		titleElement.textContent = currentActiveLink.textContent;
		lastActiveLink = currentActiveLink; // Update the last active link
	} else if (lastActiveLink) {
		titleElement.textContent = lastActiveLink.textContent;
	} else if (validNavLinks.length > 0) {
		titleElement.textContent = validNavLinks[0].textContent;
	}
}

const throttledUpdateActiveNav = throttle(updateActiveNav, 200);

updateActiveNav();

window.addEventListener('scroll', throttledUpdateActiveNav);

window.addEventListener('resize', throttledUpdateActiveNav);

// Add click event for toggling the active state
labelBlock.addEventListener('click', () => {
	if (inPageNav.classList.contains(activeClass)) {
		inPageNav.classList.remove(activeClass);
	} else {
		inPageNav.classList.add(activeClass);
	}
});
